export const pageMaxWidth = 1660;
